import WidgetCard from "@/components/cards/widget-card";
import Table from "@/components/table";
import {
    DragAbleCellWrapper,
    DragAbleHeadWrapper,
} from "@/components/table/custom";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { defaultData } from "@/data/tan-table-data";
import { DndContext, closestCenter } from "@dnd-kit/core";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";
import { defaultColumns } from "./column";

export type PersonType = (typeof defaultData)[number];

export default function TableColumnDnd() {
    const { table, setData, handleDragEndColumn, sensors, columnOrder } =
        useTanStackTable<PersonType>({
            tableData: defaultData,
            columnConfig: defaultColumns,
            options: {
                initialState: {
                    pagination: {
                        pageIndex: 0,
                        pageSize: 7,
                    },
                },
                meta: {
                    handleDeleteRow: (row) => {
                        setData((prev) => prev.filter((r) => r.id !== row.id));
                    },
                },
                enableColumnResizing: false,
            },
        });

    return (
        <WidgetCard title="Column Drag & Drop" className="space-y-4">
            <DndContext
                collisionDetection={closestCenter}
                modifiers={[restrictToHorizontalAxis]}
                onDragEnd={handleDragEndColumn}
                sensors={sensors}
            >
                <Table
                    table={table}
                    variant="elegant"
                    columnOrder={columnOrder}
                    components={{
                        headerCell: DragAbleHeadWrapper,
                        bodyCell: DragAbleCellWrapper,
                    }}
                    classNames={{
                        rowClassName: "last:border-0",
                    }}
                />
            </DndContext>
        </WidgetCard>
    );
}
